import ChartsConfigDto from "api/dtos/ChartsConfigDto";
import { ChartsDto } from "api/dtos/ChartsDto";
import { ChartsOrdersDto } from "api/dtos/ChartsOrdersDto";
import axiosInstance from "api/utils/axiosInstance";
import { constructURL, URLS } from "api/utils/baseUrls";
import { constructSearchParams } from "api/utils/constructSearchParams";

const baseChartsUrl = URLS.charts;

const getCharts = async (fieldId) => {
  const url = constructURL(baseChartsUrl);
  const params = constructSearchParams({
    fieldId,
    defaultCharts: true,
    customCharts: true,
  });

  try {
    const res = await axiosInstance.get(url, { params });
    const data = ChartsDto.fromApiArray(res.data);
    return data;
  } catch (error) {
    console.error("Error fetching charts:", error);
    throw error;
  }
};

const getChart = async (chartId) => {
  const url = constructURL(baseChartsUrl, chartId);
  try {
    const res = await axiosInstance.get(url);
    const data = ChartsDto.fromApi(res.data);
    return data;
  } catch (error) {
    console.error("Error fetching chart:", error);
    throw error;
  }
};

const getChartsConfig = async () => {
  const url = constructURL(baseChartsUrl, "config");
  try {
    const res = await axiosInstance.get(url);
    const data = ChartsConfigDto.fromApiArray(res.data);
    return data;
  } catch (error) {
    console.error("Error fetching charts config:", error);
    throw error;
  }
};

const createChart = async (chartData) => {
  const url = constructURL(baseChartsUrl, "create");
  try {
    const payload = ChartsDto.toApi(chartData);
    const res = await axiosInstance.post(url, payload);
    const data = ChartsDto.fromApi(res.data);
    return data;
  } catch (error) {
    console.error("Error creating chart:", error);
    throw error;
  }
};

const updateChart = async (chartId, chartData) => {
  const url = constructURL(baseChartsUrl, chartId);
  const payload = ChartsDto.toApi(chartData);
  const res = await axiosInstance.put(url, payload);
  const data = ChartsDto.fromApi(res.data);
  return data;
};

const reorderCharts = async (fieldId, ordersDictionary = {}) => {
  const url = constructURL(baseChartsUrl, "reorder");
  const payload = ChartsOrdersDto.toApi(fieldId, ordersDictionary);
  const res = await axiosInstance.post(url, payload);
  const data = res.data;
  return data;
};

const deleteChart = async (chartId) => {
  const url = constructURL(baseChartsUrl, chartId);
  try {
    const res = await axiosInstance.delete(url);
    const data = res.data;
    return data;
  } catch (error) {
    console.error("Error deleting chart:", error);
    throw error;
  }
};

export const chartsApi = {
  fetchAll: getCharts,
  fetchOne: getChart,
  fetchConfig: getChartsConfig,
  create: createChart,
  update: updateChart,
  reorder: reorderCharts,
  delete: deleteChart,
};
